import React, { useEffect, useRef, useState } from 'react';
import { Animated, Easing, Text } from 'react-native';
import styled from 'styled-components/native';
import {
  WorkoutTextHeader
} from '../../../styles/common-styles';

function BreatherElement({animSpeed, delayLength}) {
  // Create an animated value and attach it to the ref
  const size = useRef(new Animated.Value(150)).current;
  const colorAnimation = useRef(new Animated.Value(0)).current; // Animated value for background color

  // Define a state variable to keep track of the current phase of the animation
  const [animationState, setAnimationState] = useState('Inhale');

  // This effect hook will handle the inhale and hold phases of the animation
  useEffect(() => {
    // Only proceed if the animation is in the inhale or hold phase
    if (animationState === 'Inhale' || animationState === 'Hold') {
      // Define the grow animation
      const growAnimation = Animated.timing(size, {
        toValue: 250,
        duration: animSpeed,
        useNativeDriver: false,
      });

      // Define the color animation
      const colorChangeAnimation = Animated.timing(colorAnimation, {
        toValue: 1, // animate from 0 to 1
        duration: animSpeed,
        useNativeDriver: false,
      });

      // Start the animations simultaneously
      Animated.parallel([growAnimation, colorChangeAnimation]).start(() => {
        // If the animation was in the inhale phase, change to hold and then to exhale after the delay
        if (animationState === 'Inhale') {
          setAnimationState('Hold');
          setTimeout(() => setAnimationState('Exhale'), delayLength);
        }
        // If the animation was in the hold phase, change to exhale immediately
        else if (animationState === 'Hold') {
          setAnimationState('Exhale');
        }
      });
    }
  }, [animationState]);

  // This effect hook will handle the exhale and pause phases of the animation
  useEffect(() => {
    // Only proceed if the animation is in the exhale or pause phase
    if (animationState === 'Exhale' || animationState === 'Pause') {
      // Define the shrink animation
      const shrinkAnimation = Animated.timing(size, {
        toValue: 150,
        duration: animSpeed,
        useNativeDriver: false,
      });

      // Define the color animation
      const colorChangeAnimation = Animated.timing(colorAnimation, {
        toValue: 0, // animate back to 0
        duration: animSpeed,
        useNativeDriver: false,
      });

      // Start the animations simultaneously
      Animated.parallel([shrinkAnimation, colorChangeAnimation]).start(() => {
        // If the animation was in the exhale phase, change to pause and then to inhale after the delay
        if (animationState === 'Exhale') {
          setAnimationState('Pause');
          setTimeout(() => setAnimationState('Inhale'), delayLength);
        }
        // If the animation was in the pause phase, change to inhale immediately
        else if (animationState === 'Pause') {
          setAnimationState('Inhale');
        }
      });
    }
  }, [animationState]);

  // Interpolate color changes
  const backgroundColor = colorAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: ['#C04C97', '#3366CC']
  });

  // Render the animated view with the current size and animation state
  return (
      <BreatherParent>
        <Breather
            style={{
              width: size,
              height: size,
              borderRadius: size.interpolate({
                inputRange: [0, 250],
                outputRange: [0, 125],
              }),
              backgroundColor, // interpolated backgroundColor
            }}
        >
          {animationState != "Pause" && (
              <WorkoutTextHeader style={{ color: 'white', fontSize: 24 }}>{animationState}</WorkoutTextHeader>
          )}
        </Breather>
      </BreatherParent>
  );
}

// Define a styled component for the animated view
export const BreatherParent = styled.View`
  width:250px;
  height:250px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin-bottom:150px;
`

export const Breather = styled(Animated.View)`
  align-items: center;
  justify-content: center;
  
`;

export default BreatherElement;
